require('./popsale-bootstrap');

window.Vue = require('vue');

window.Vuetify = require('vuetify');
Vue.use(Vuetify);

Vue.component(
    'offer-photo-carousel',
    require('./popsale-components/OfferPhotoCarousel.vue').default
);

Vue.component(
    'offer-ads-modal',
    require('./popsale-components/OfferAdsModal.vue').default
);

Vue.component(
    'example',
    require('./components/Example.vue').default
);